<div
	class="quote-card"
	[class.quote-card--gone]="!quote"
	[class.quote-card--item]="isItem"
>
	<!-- Editor only. A card of a list offers Keep this one alone; the list
	     hides its authors itself, and a post it read cannot be swapped. -->
	<div
		class="quote-card__controls"
		*ngIf="editorMode && isItem && quote"
		role="toolbar"
		aria-label="Mention in the list"
	>
		<button
			type="button"
			class="quote-card__control"
			[disabled]="busy"
			matTooltip="Add this mention after the list as a quote card of its own, kept whatever the period"
			matTooltipPosition="above"
			matTooltipClass="sentiment-tooltip"
			(click)="keepThis()"
		>
			<app-icon type="svg" [size]="14" color="currentColor">pin</app-icon>
			<typography
				variant="p/xxs_semibold"
				class="quote-card__control-label"
			>
				Keep this one
			</typography>
		</button>
	</div>

	<!-- Editor only. Swap mention stays on a card whose mention is gone:
	     another one in its place is the way out of the empty state. -->
	<div
		class="quote-card__controls"
		*ngIf="editorMode && !isItem"
		role="toolbar"
		aria-label="Quote card"
	>
		<button
			*ngIf="quote"
			type="button"
			class="quote-card__control"
			[attr.aria-pressed]="quote.author_hidden"
			[disabled]="busy"
			[matTooltip]="
				quote.author_hidden
					? 'Show who wrote it again'
					: 'Hide the name, handle, picture and link to the post'
			"
			matTooltipPosition="above"
			matTooltipClass="sentiment-tooltip"
			(click)="toggleAuthor()"
		>
			<app-icon type="svg" [size]="14" color="currentColor">
				{{ quote.author_hidden ? 'eye_big' : 'eye_big_slash' }}
			</app-icon>
			{{ quote.author_hidden ? 'Show author' : 'Hide author' }}
		</button>
		<button
			type="button"
			class="quote-card__control"
			[disabled]="busy || !brandId"
			matTooltip="Quote another of the brand's mentions from this period"
			matTooltipPosition="above"
			matTooltipClass="sentiment-tooltip"
			(click)="swap()"
		>
			<app-icon type="svg" [size]="14" color="currentColor">
				refresh
			</app-icon>
			Swap mention
		</button>
	</div>

	<ng-container *ngIf="quote; else gone">
		<span
			class="quote-card__mark"
			aria-hidden="true"
			[style.color]="themeColor || null"
		>
			“
		</span>

		<!-- TRAP: plain elements like the rest of the card, not typography —
		     typography forces Gilroy with !important over the theme's report font. -->
		<div
			class="quote-card__origin"
			*ngIf="originMark"
			data-testid="quote-origin-mark"
		>
			<span class="quote-card__origin-label">{{ originMark }}</span>
			<a
				*ngIf="parentPostUrl"
				class="quote-card__origin-link"
				[href]="parentPostUrl"
				target="_blank"
				rel="noopener noreferrer"
			>
				View the post
			</a>
		</div>

		<p class="quote-card__headline" *ngIf="quote.title">
			{{ quote.title }}
		</p>
		<!-- Bound, not interpolated: the text keeps the post's own line
		     breaks, and markup around an interpolation would add some. -->
		<blockquote
			class="quote-card__text"
			[textContent]="quote.text"
		></blockquote>

		<div class="quote-card__footer">
			<div class="quote-card__author">
				<div class="quote-card__avatar">
					<span class="quote-card__initials" *ngIf="initials">
						{{ initials }}
					</span>
					<img
						*ngIf="quote.author_image"
						class="quote-card__avatar-image"
						[src]="quote.author_image"
						alt=""
						(error)="hideBrokenImage($event)"
					/>
					<app-social-listening-platform-icon
						class="quote-card__platform"
						[size]="16"
						[socialListeningPlatform]="platform"
					></app-social-listening-platform-icon>
				</div>

				<div class="quote-card__who">
					<span class="quote-card__name">
						<ng-container *ngIf="!quote.author_hidden; else hidden">
							{{ quote.author_name || platformLabel }}
						</ng-container>
						<ng-template #hidden>Author hidden</ng-template>
						<app-icon
							*ngIf="quote.author_verified"
							type="svg"
							[size]="12"
						>
							social_verified
						</app-icon>
					</span>
					<span class="quote-card__meta">
						<ng-container *ngIf="handle">
							{{ handle }} ·
						</ng-container>
						{{ platformLabel }}
						<ng-container *ngIf="quote.posted_at">
							· {{ quote.posted_at | date: 'd MMM y':'UTC' }}
						</ng-container>
					</span>
				</div>
			</div>

			<div class="quote-card__facts">
				<!-- The engagement a social post carries, as its card in the
				     feed shows it: a dash where nothing was measured. A web
				     page has none of these, so it shows none. -->
				<ng-container *ngIf="!isWebSource">
					<span class="quote-card__fact" title="Likes">
						<app-icon type="svg" color="#6b7796" [size]="14">
							instagram_likes
						</app-icon>
						{{ quote.likes | shortNumber }}
					</span>
					<span class="quote-card__fact" title="Comments">
						<app-icon type="svg" color="#6b7796" [size]="14">
							instagram_comments
						</app-icon>
						{{ quote.comments | shortNumber }}
					</span>
					<span class="quote-card__fact" title="Views">
						<app-icon type="svg" color="#6b7796" [size]="14">
							eye
						</app-icon>
						{{
							quote.views == null
								? '—'
								: (quote.views | shortNumber)
						}}
					</span>
					<span class="quote-card__fact">
						Eng. rate
						<strong>
							{{
								quote.engagement_rate == null
									? '—'
									: (quote.engagement_rate
											| number: '1.0-2') + '%'
							}}
						</strong>
					</span>
					<span class="quote-card__fact">
						Reach
						<strong>
							{{
								quote.reach == null
									? '—'
									: (quote.reach | shortNumber)
							}}
						</strong>
					</span>
				</ng-container>
				<span
					class="quote-card__sentiment"
					[class.quote-card__sentiment--positive]="
						quote.sentiment === 'positive'
					"
					[class.quote-card__sentiment--negative]="
						quote.sentiment === 'negative'
					"
				>
					{{ sentimentLabel }}
				</span>
				<a
					*ngIf="quote.url"
					class="quote-card__link"
					[href]="quote.url"
					target="_blank"
					rel="noopener noreferrer"
				>
					<app-icon type="svg" [size]="12" color="currentColor">
						external_link
					</app-icon>
					View post
				</a>
			</div>
		</div>
	</ng-container>

	<ng-template #gone>
		<app-slide-no-data [message]="goneNote"></app-slide-no-data>
	</ng-template>
</div>
